<template>
    <header class="header">
        <div class="navbar-fixed header-operator-desktop">
            <div :class="`content flex justify-${headerOrientation}`">
                <a class="brand-logo-contrator-desktop flex justify-center">
                    <img :src="logo" alt="Engelink" />
                    <template v-if="Titlepage">
                        <span class="division"></span>
                        <span class="title-page">{{ Titlepage }}</span>
                    </template>
                </a>
                <div v-if="!isMobile">
                    <div
                        @click="sendWhatsAppMessage"
                        class="wa-button"
                    >
                        <img src="../../assets/images/whatsapp.svg">
                        Solicite pelo whatsapp
                    </div>
                    <!-- <eg-button @click="sendEmail" variant="eg-blue-outline-dark"
                        ><span class="material-icons-outlined mr-1"> email </span>solicitacao@engelink.com.br</eg-button
                    >-->
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { computed } from '@vue/composition-api';
import { getState } from '@/composibles/title-header';
export default {
    props: {
        isMobile: [Object, Boolean],
    },
    setup (props) {
        const Titlepage = computed(() => getState.state.title || '');
        const MainPhone = computed(() => getState.state.mainPhone || '');

        const logo = computed(() => {
            if (Titlepage.value) {
                return require('@/assets/images/logo-corrente.png');
            } else {
                return require('@/assets/images/logo-blue.png');
            }
        });

        const headerOrientation = computed(() => (props.isMobile ? 'center' : 'between'));

        const sendWhatsAppMessage = () => {
            window.open(
                'https://api.whatsapp.com/send/?phone=' + '55' + formatPhone(MainPhone.value),
                '_blank'
            );
        };
        const sendEmail = () => {
            window.open('mailto:solicitacao@engelink.com.br', '_blank');
        };

        const formatPhone = (phone) => {
            const numsStr = phone.replace(/[^0-9]/g,'');
            return numsStr
        }

        return { logo, Titlepage, headerOrientation, sendWhatsAppMessage, sendEmail, MainPhone, formatPhone };
    },
};
</script>

<style lang="scss" scoped>
.content {
    @apply container mx-auto px-8;
    display: flex;
    align-items: center;
    height: 53px;
}
.material-icons-outlined {
    font-size: 16px;
}
.division {
    color: #7a7a7a;
    width: 22px;
    left: 43.99px;
    top: 17px;

    border: 1px solid #dbdbdb;
    background-color: #dbdbdb;
    transform: rotate(106deg);
}
.title-page {
    font-family: Open Sans;
    font-style: italic;
    font-weight: bold;
    font-size: 16px;
    text-transform: uppercase;
    color: #7a7a7a;
}
.header-operator-desktop {
    background-color: #ffffff;
    z-index: 999 !important;
    height: 53px;
    // line-height: 53px;
    box-shadow: 0px 3px 6px #00000029;
}
.navbar-fixed {
    top: 0;
    position: fixed;
    width: 100%;
    z-index: 1;
}

.header {
    height: 53px;
}

// .header-operator-desktop .container {
//     width: 90%;
// }

.brand-logo-contrator-desktop {
    align-items: center;
    display: flex;
    // flex-grow: 1;
    justify-content: flex-start;
    // margin-left: 20px;
}
@media screen and (max-width: 992px) {
    .title-page {
        font-size: 14px !important;
    }
}

.wa-button {
    background-color: #25D366 !important;
    box-shadow: inset 0px 0px 1px 1px #25D366 !important; 
    color: #fff !important;
    padding: 8px 16px;
    text-transform: uppercase;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 260px;
    gap: 10px;
    cursor: pointer;
    img {
        max-width: 15px;
        fill: #fff;
    }
}
</style>
